import { render, staticRenderFns } from "./IntroEventsFeedWidget.vue?vue&type=template&id=9a03afa6&"
import script from "./IntroEventsFeedWidget.vue?vue&type=script&lang=js&"
export * from "./IntroEventsFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a03afa6')) {
      api.createRecord('9a03afa6', component.options)
    } else {
      api.reload('9a03afa6', component.options)
    }
    module.hot.accept("./IntroEventsFeedWidget.vue?vue&type=template&id=9a03afa6&", function () {
      api.rerender('9a03afa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/IntroEventsFeedWidget.vue"
export default component.exports